import { render, staticRenderFns } from "./ProductPreviewVideo.vue?vue&type=template&id=1b2b307a&scoped=true&"
import script from "./ProductPreviewVideo.vue?vue&type=script&lang=js&"
export * from "./ProductPreviewVideo.vue?vue&type=script&lang=js&"
import style0 from "./ProductPreviewVideo.vue?vue&type=style&index=0&id=1b2b307a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2b307a",
  null
  
)

export default component.exports